import React from 'react';
import {Navbar, Container, Nav, NavDropdown, Form} from "react-bootstrap";
import './main.scss';
import oe_logo from "../../images/oe_logo.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";


function Navigation() {
    return (
        <div className="App">
            <header>
                <Container>
                    <Navbar expand="md">
                        <Navbar.Brand href="./"><img src={oe_logo} alt="Orb Explorer"/></Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarTog" ><FontAwesomeIcon icon={faBars} className="navToggle" /></Navbar.Toggle>
                        <Navbar.Collapse id="navbarTog">
                            <Form className="d-flex">
                                <input type="search" id="search" name="search" placeholder="Search address, collection or asset" size={50}/>
                                {/* <input type="submit" className="btn-grad" value="Search" /> */}
                            </Form>
                            <Nav className="ms-auto">
                                <Nav.Link href="/MyWallet">My wallet</Nav.Link>
                                <NavDropdown title="Browse">
                                    <NavDropdown.Item href="/Collections">Collections</NavDropdown.Item>
                                    <NavDropdown.Item href="/Assets">Assets</NavDropdown.Item>
                                    <NavDropdown.Item href="/Transactions">Transactions</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link href="/About">About</Nav.Link>
                                <Nav.Link href="#action5">Connect Wallet</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Container>
            </header>
        </div>
    );
}

export default Navigation;
